import { render, staticRenderFns } from "./TemplateQuestionaire.vue?vue&type=template&id=8ec97300&"
import script from "./TemplateQuestionaire.vue?vue&type=script&lang=js&"
export * from "./TemplateQuestionaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports